export const FILTER_KEYS = {
  COMPANY_ID: 'companyId',
  ROLE_IDS: 'roleIds',
  ACCESS_LEVELS: 'accessLevels',
  PRODUCTS: 'products',
  STATUS: 'status',
};
